import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-component p-formgrid p-grid p-input-filled" }
const _hoisted_2 = { for: "name" }
const _hoisted_3 = {
  key: 0,
  class: "p-error"
}
const _hoisted_4 = {
  key: 1,
  class: "p-error"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { for: "description" }
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}
const _hoisted_8 = { for: "locatorType" }
const _hoisted_9 = {
  key: 0,
  class: "p-error"
}
const _hoisted_10 = { for: "dataType" }
const _hoisted_11 = { for: "searchPages" }
const _hoisted_12 = { for: "sourceLocatorId" }
const _hoisted_13 = { class: "p-field p-col-6" }
const _hoisted_14 = { for: "ignoreWhiteSpaces" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "p-field p-col-6" }
const _hoisted_17 = { for: "active" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["p-field", _ctx.showSingleLinedForm ? 'p-col-12' : 'p-col-6'])
    }, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('Squeeze.Locators.Name')) + " *", 1),
      _createVNode(_component_InputText, {
        id: "name",
        modelValue: _ctx.v$.name.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.name.$model) = $event)),
        modelModifiers: { trim: true },
        class: _normalizeClass({'p-invalid':_ctx.v$.name.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update,
        required: "true",
        autofocus: ""
      }, null, 8, ["modelValue", "class", "onChange"]),
      (_ctx.v$.name.required.$invalid && _ctx.showErrorMessage && !_ctx.v$.name.technicalValidation.$invalid)
        ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.Locators.Name')})), 1))
        : _createCommentVNode("", true),
      (_ctx.v$.name.technicalValidation.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.$t('Forms.Val.OnlyAllowAlphaNumericUnderscore', { field: _ctx.$t('Squeeze.Locators.Name')})), 1))
        : (!!_ctx.value.id)
          ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.$t('Squeeze.Admin.WarnRename')), 1))
          : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["p-field", _ctx.showSingleLinedForm ? 'p-col-12' : 'p-col-6'])
    }, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('Squeeze.Locators.Description')) + " *", 1),
      _createVNode(_component_InputText, {
        id: "description",
        modelValue: _ctx.v$.description.$model,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.description.$model) = $event)),
        modelModifiers: { trim: true },
        class: _normalizeClass({'p-invalid':_ctx.v$.description.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update,
        required: "true"
      }, null, 8, ["modelValue", "class", "onChange"]),
      ((_ctx.v$.description.$invalid && _ctx.showErrorMessage))
        ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.Locators.Description')})), 1))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["p-field", _ctx.showSingleLinedForm ? 'p-col-12' : 'p-col-6'])
    }, [
      _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('Squeeze.Locators.LocatorType')) + " *", 1),
      _createVNode(_component_Dropdown, {
        id: "locatorType",
        style: {"min-width":"250px"},
        modelValue: _ctx.v$.locatorType.$model,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.locatorType.$model) = $event)),
        options: _ctx.locatorTypes,
        class: _normalizeClass({'p-invalid':_ctx.v$.locatorType.$invalid && _ctx.showErrorMessage}),
        filter: true,
        autoFilterFocus: true,
        optionValue: "value",
        optionLabel: "description",
        editable: false,
        onChange: _ctx.update,
        required: "true",
        onShow: _ctx.showDropdownOverlay
      }, null, 8, ["modelValue", "options", "class", "onChange", "onShow"]),
      (_ctx.v$.locatorType.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.Locators.LocatorType')})), 1))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["p-field", _ctx.showSingleLinedForm ? 'p-col-12' : 'p-col-6'])
    }, [
      (_ctx.locator.locatorType !== 2)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('Squeeze.Locators.DataType')), 1),
            _createVNode(_component_Dropdown, {
              id: "dataType",
              style: {"min-width":"250px"},
              modelValue: _ctx.value.dataType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value.dataType) = $event)),
              options: _ctx.dataTypes,
              optionValue: "id",
              optionLabel: "text",
              onChange: _ctx.update
            }, null, 8, ["modelValue", "options", "onChange"])
          ], 64))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["p-field", _ctx.showSingleLinedForm ? 'p-col-12' : 'p-col-6'])
    }, [
      _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('Squeeze.Locators.SearchPages')), 1),
      _createVNode(_component_Dropdown, {
        id: "searchPages",
        style: {"min-width":"250px"},
        modelValue: _ctx.value.searchPages,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.value.searchPages) = $event)),
        options: _ctx.searchPages,
        filter: false,
        optionValue: "id",
        optionLabel: "description",
        editable: false,
        onChange: _ctx.update
      }, null, 8, ["modelValue", "options", "onChange"])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["p-field", _ctx.showSingleLinedForm ? 'p-col-12' : 'p-col-6'])
    }, [
      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('Squeeze.Locators.SourceLocatorId')), 1),
      _createVNode(_component_Dropdown, {
        id: "sourceLocatorId",
        style: {"min-width":"250px"},
        modelValue: _ctx.value.sourceLocatorId,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.value.sourceLocatorId) = $event)),
        options: _ctx.locators.filter(loc => loc.id !== _ctx.locator.id),
        filter: true,
        autoFilterFocus: true,
        optionValue: "id",
        optionLabel: "description",
        editable: false,
        onChange: _ctx.update,
        onShow: _ctx.showDropdownOverlay
      }, null, 8, ["modelValue", "options", "onChange", "onShow"])
    ], 2),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('Squeeze.Locators.IgnoreWhiteSpaces')), 1),
      _hoisted_15,
      _createVNode(_component_Checkbox, {
        id: "ignoreWhiteSpaces",
        onChange: _ctx.update,
        modelValue: _ctx.value.ignoreWhiteSpaces,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.value.ignoreWhiteSpaces) = $event)),
        binary: true
      }, null, 8, ["onChange", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('Squeeze.Locators.Active')), 1),
      _hoisted_18,
      _createVNode(_component_Checkbox, {
        id: "active",
        onChange: _ctx.update,
        modelValue: _ctx.value.active,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.value.active) = $event)),
        binary: true
      }, null, 8, ["onChange", "modelValue"])
    ])
  ]))
}